import DLSTooltip from "../../../dls/dls-tooltip-new";
import { IDSSTooltipProps } from "../../DSSFramework";

export const DSSTooltip = ({ text, children }: IDSSTooltipProps) => {
    return (
        <DLSTooltip text={text}>
            {children}
        </DLSTooltip>
    );
};